import { api } from '../api/client';

/**
 * Fetches a CSV export endpoint WITH the auth header (via the shared axios
 * client) and triggers a browser download. The endpoint returns text/csv.
 */
export async function downloadCsv(
  path: string,
  params: Record<string, string | number | undefined>,
  filename: string,
): Promise<void> {
  const res = await api.get(path, {
    params,
    responseType: 'blob',
  });
  const blob = new Blob([res.data], { type: 'text/csv;charset=utf-8;' });
  triggerBlobDownload(blob, filename);
}

export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}
